import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal, Button, Row } from 'antd';
import { BellOutlined, UserAddOutlined } from '@ant-design/icons';
import Loading from 'components/Loading';
import ButtonIcon from 'components/Button/ButtonIcon';
import { fetchNotificationApp, fetchStatusModalUsuarioPendente } from 'store/fetchActions/fetchApp';
import { fetchAtualizarAtendente, fetchGetAtendenteById } from 'store/fetchActions/fetchAtendente';
import { ENUM_CONDICAO_STATUS, MSG_ATENDENTE_EDITADO_SECESSO, ALERTA } from 'utils/consts';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { formatterAtendenteBackToBackUpdate } from 'utils/formatter/atendente';
import { getLabelCargoFas } from 'utils/funcaoPadrao';
import { cpfMaskView } from 'utils/masks';
import * as S from './styles';

export const ModalAcessoNegado = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);
  const modalState = useSelector(state => state.app.modalUsuarioPendente);
  const modalAcessoNegado = useSelector(state => state.app.modalAcessoNegado);

  const [listaAtendentePendente, setListaAtendentePendente] = useState(modalState?.props?.lista || []);

  const onClose = () => {
    dispatch(fetchStatusModalUsuarioPendente(false, modalState?.title));
  };

  React.useEffect(() => {
    if (modalAcessoNegado?.isOpen && modalState?.isOpen) {
      dispatch(fetchStatusModalUsuarioPendente(false, modalState?.title));
    }
  }, [dispatch, modalAcessoNegado, modalState]);

  React.useEffect(() => {
    setListaAtendentePendente(modalState?.props?.lista || []);
  }, [modalState]);

  React.useEffect(() => {
    if (modalState?.props?.lista?.length > 0 && listaAtendentePendente?.length === 0) {
      onClose();
    }
    // eslint-disable-next-line
  }, [listaAtendentePendente]);

  const handleAceitar = atendente => {
    const atendenteSalvar = { ...atendente, condicaoId: ENUM_CONDICAO_STATUS.APROVADO.id };
    const dadosFormatados = formatterAtendenteBackToBackUpdate(atendenteSalvar, user?.cpf_cnpj);
    dispatch(fetchAtualizarAtendente(dadosFormatados)).then(() => {
      setListaAtendentePendente(listaAtendentePendente.filter(x => x.id !== atendente.id));
      fetchNotificationApp(MSG_ATENDENTE_EDITADO_SECESSO, '', ALERTA.SUCESSO);
    });
  };

  const handleRecusar = atendente => {
    const atendenteSalvar = { ...atendente, condicaoId: ENUM_CONDICAO_STATUS.RECUSADO.id };
    const dadosFormatados = formatterAtendenteBackToBackUpdate(atendenteSalvar, user?.cpf_cnpj);
    dispatch(fetchAtualizarAtendente(dadosFormatados)).then(() => {
      setListaAtendentePendente(listaAtendentePendente.filter(x => x.id !== atendente.id));
      fetchNotificationApp(MSG_ATENDENTE_EDITADO_SECESSO, '', ALERTA.SUCESSO);
    });
  };

  const handleDetalhar = atendente => {
    dispatch(fetchGetAtendenteById(atendente?.id, history));
    onClose();
  };

  const renderPerfilSemCadastro = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <S.Titulo>
          Existe ({listaAtendentePendente?.length}) novas solicitações de usuários aguardando sua aprovação.
        </S.Titulo>
        <S.ContainerRow>
          <div style={{ height: '90px' }}>
            <BellOutlined />
          </div>
        </S.ContainerRow>
        <S.ContainerLabel>
          {listaAtendentePendente?.map(atendente => {
            return (
              <S.FraseAcessoSolicitacao key={atendente?.documento}>
                <S.TituloSolicitacao>
                  <UserAddOutlined />
                  <b>{atendente?.apelido}</b> <i>{atendente?.email}</i>
                </S.TituloSolicitacao>
                <b>{atendente?.nome}</b> de CPF <b>{cpfMaskView(atendente?.documento)}</b>, gostaria de ativar o
                cadastro no FAS como
                <b>{getLabelCargoFas(atendente?.cargoId, atendente?.isSetorial)}</b>
                <p style={{ margin: '10px' }}>
                  <i>{convertDatePtBrHs(atendente?.dataCadastro)}</i>
                </p>
                <Row>
                  <ButtonIcon
                    data-testid="btnSalvar"
                    icon="SALVAR"
                    clickAction={() => handleAceitar(atendente)}
                    tooltipMessage={'Aceitar'}
                  />
                  <ButtonIcon
                    data-testid="btnDeletar"
                    icon="DELETAR"
                    clickAction={() => handleRecusar(atendente)}
                    tooltipMessage={'Recusar'}
                  />
                  <ButtonIcon
                    data-testid="btnFiltrar"
                    icon="FILTRAR"
                    clickAction={() => handleDetalhar(atendente)}
                    tooltipMessage={'Detalhar'}
                  />
                </Row>
              </S.FraseAcessoSolicitacao>
            );
          })}
        </S.ContainerLabel>
      </div>
    );
  };

  return (
    <Modal
      title={modalState?.title}
      centered
      visible={modalState?.isOpen}
      onCancel={onClose}
      width={750}
      closable={false}
      footer={[
        <Button key="back" onClick={onClose}>
          Fechar
        </Button>,
      ]}
    >
      <Loading>{renderPerfilSemCadastro()}</Loading>
    </Modal>
  );
};

export default ModalAcessoNegado;
